import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/product/customer_order/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'N', value: 'notion_id', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Customer', value: 'customer_name', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'Product', value: 'product_name', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'date_receipt', value: 'date_receipt', sortable: true, filterable: true, divider: true, brief: true, type: 'date',},
        {text: 'editors list', value: 'editors_list', sortable: false, filterable: true, divider: true, brief: true,},
        // {text: 'Type*', value: 'typ', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'lot_size', value: 'lot_size', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'receipt_confirmed', value: 'receipt_confirmed', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'purchasing', value: 'purchasing', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'provision', value: 'provision', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'ab', value: 'ab', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'Hints*', value: 'hints', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'smd', value: 'smd', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'tht', value: 'tht', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'extra', value: 'extra', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'mat_vk', value: 'mat_vk', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'po_extra', value: 'po_extra', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'lp_vk', value: 'lp_vk', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'po_einmal', value: 'po_einmal', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'mat_ek', value: 'mat_ek', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'lp_ek', value: 'lp_ek', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'ek_einmal', value: 'ek_einmal', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'quantities_dates', value: 'quantities_dates', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'ab_quantities_dates', value: 'ab_quantities_dates', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'desired_date', value: 'desired_date', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'frame', value: 'frame', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'update_production', value: 'update_production', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'sn', value: 'sn', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'lt_plan_mat', value: 'lt_plan_mat', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'lt_plan_ist', value: 'lt_plan_ist', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'lt_amount', value: 'lt_amount', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'generator_status', value: 'generator_status', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'handover_comment', value: 'handover_comment', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'prepayments', value: 'prepayments', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'ems_alt', value: 'ems_alt', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'sync_quantities_dates', value: 'sync_quantities_dates', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'task_id', value: 'task_id', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'task_status', value: 'task_status', sortable: true, filterable: true, divider: true, brief: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, brief: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true, type: 'datetime',},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
    statusCustomerOrder: [
        {name: 'Vorbereitung', color: 'grey lighten-5'},
        {name: 'In Klärung', color: 'red lighten-5'},
        {name: 'Produktion', color: 'blue lighten-5'},
        {name: 'Lager', color: 'light-green lighten-5'},
        {name: 'Komplett ausgeliefert', color: 'grey lighten-5'},
        {name: 'Zurückgezogen', color: 'amber lighten-5'},
    ],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
    getStatusCustomerOrder(state) {
        let result = []
        for (let row of state.statusCustomerOrder)
            result.push(row.name)
        return result
    }
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        CustomerOrderTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}